import { render, staticRenderFns } from "./typeinword.vue?vue&type=template&id=01537779&scoped=true"
import script from "./typeinword.vue?vue&type=script&lang=js"
export * from "./typeinword.vue?vue&type=script&lang=js"
import style0 from "./typeinword.vue?vue&type=style&index=0&id=01537779&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01537779",
  null
  
)

export default component.exports